import ApplicationCategory from '@apps/ApplicationCategory'
import { serverApi as api } from '@common/api'
import { AppStoreUrls } from '@common/api/urls'
import { appListLimits as limit, sortOrders } from '@common/constants'
import catchGetServerSide from '@common/utils/catchGetServerSide'
import {
  topEarningInitialize,
} from '@redux/slices/applicationList'
import type { IData } from '@redux/slices/applicationList/applicationList.types'
import { wrapper } from '@redux/store'
import type { GetServerSideProps } from 'next'


export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps(store => async ({ query }) => {
  try {
    const search = query.q as string | undefined
    const page = query.page as string
    const offset = (typeof page === 'string' && page !== '' && Number(page) > 0) ? (Number(page) - 1) * limit : 0
    const url = AppStoreUrls.app_list()
    const data = await api.get<IData>(url, { params: { ...sortOrders.topEarning, limit, offset, search } })
    store.dispatch(topEarningInitialize(data))
  } catch (e) {
    return catchGetServerSide(e)
  }

  return {
    props: { },
  }
})


// http://localhost:3000/apps/top-earning
export default function topEarning(): JSX.Element {
  return <ApplicationCategory title="Top earning apps" reducer="topEarning"/>
}
